import SiteLayout from "@/components/feature/SiteLayout";
import NewsTicker from "@/components/feature/NewsTicker";
import SiteCtaBand from "@/components/feature/SiteCtaBand";
import { useSeo } from "@/hooks/useSeo";
import { topics } from "@/mocks/topics";
import HeroSection from "@/pages/home/components/HeroSection";
import CategoryStrip from "@/pages/home/components/CategoryStrip";
import AttitudeBoard from "@/pages/home/components/AttitudeBoard";
import CommentWall from "@/pages/home/components/CommentWall";
import PollSnapshot from "@/pages/home/components/PollSnapshot";
import TopicGrid from "@/pages/home/components/TopicGrid";

export default function Home() {
  useSeo({
    title: "爆料看点 - 评论区高能回复、网友神评论与投票结果展示",
    description:
      "爆料看点汇聚全网争议事件的评论区高能回复、网友神评论与投票结果，同步展示舆论态度分布。想先看站队和风向，点开一个页面就能看清大家都在讨论什么。",
    keywords:
      "爆料看点,评论区高能回复,网友神评论,投票结果展示,舆论态度分布",
    path: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "爆料看点",
        url: "https://qrwho.cn/",
        inLanguage: "zh-CN",
        description:
          "汇聚评论区高能回复、网友神评论与投票结果展示的内容平台。",
        potentialAction: {
          "@type": "SearchAction",
          target:
            "https://qrwho.cn/topics?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "爆料看点",
        url: "https://qrwho.cn/",
        email: "baoliao@example.com",
        description:
          "把事件、评论区高能回复、网友神评论与投票结果集中呈现的吃瓜风向站。",
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "今日热榜",
        itemListElement: topics.slice(0, 8).map((topic, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: topic.title,
          url: `https://qrwho.cn/topics/${topic.id}`,
        })),
      },
    ],
  });

  return (
    <SiteLayout>
      <HeroSection />
      <NewsTicker />
      <CategoryStrip />
      <AttitudeBoard />
      <CommentWall />
      <PollSnapshot />
      <TopicGrid />
      <SiteCtaBand />
    </SiteLayout>
  );
}